export default {
  ONE: 'TEMPLATE_1', // DEFAULT
  TWO: 'TEMPLATE_2'
};
